import CustomButton from "../../../../../../components/CustomButton";

import SvgIcon from "../../../../../../helpers/SvgIcon";

import { useAppDispatch } from "../../../../../../redux/hooks";
import { CargoNodeDataInterface } from "../../../../../../redux/interfaces/raports.interface";
import {
  openFinishingDeliveryModal,
  setSelectedFinishingDeliveryData,
} from "../../../../../../redux/reducer/raports.reducer";

function CargoActionButton({
  crudData,
}: {
  itemId: string;
  crudData: CargoNodeDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();

  const handleFinishDelivery = () => {
    dispatch(openFinishingDeliveryModal());
    dispatch(setSelectedFinishingDeliveryData(crudData));
  };

  return (
    <div>
      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        tooltipTitle="Finalizeaza livrarea"
        onClick={handleFinishDelivery}>
        <SvgIcon type="DELIVERED_AWB" fill="white" />
      </CustomButton>
    </div>
  );
}

export default CargoActionButton;
